'use client'

import { LanguageDropdown } from '@/components/language-dropdown'
import { FullscreenToggle } from '@/components/layout/full-screen-toggle'
import { NotificationBell } from '@/components/layout/notification-bell'
import { UserDropdown } from '@/components/layout/user-dropdown'
import { ModeDropdown } from '@/components/mode-dropdown'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { HelpButton } from '@/help/components/help-button'
import { RecordNav } from '../record-nav'
import { ToggleMobileSidebar } from '../toggle-mobile-sidebar'

export function VerticalLayoutHeader() {
  return (
    <header className="sticky top-0 z-50 w-full bg-background border-b border-sidebar-border">
      <div className="flex h-14 justify-between items-center gap-4 mx-4">
        <ToggleMobileSidebar />
        <div className="grow flex items-center justify-end gap-2">
          {/* xl (1280px) must match useIsMobile's MOBILE_BREAKPOINT: ToggleMobileSidebar shows below it,
              so using lg here renders a second toggle in the 1024-1279px band. */}
          <SidebarTrigger className="hidden xl:flex" />
          <div className="hidden lg:flex lg:me-auto lg:ms-2 items-center">
            <RecordNav />
          </div>
          <HelpButton />
          <NotificationBell />
          <FullscreenToggle />
          <ModeDropdown />
          <LanguageDropdown />
          <UserDropdown />
        </div>
      </div>
    </header>
  )
}
